// B3.7 — per-mode discovery tour mapping (dwell + offer copy).

import type { PrimaryMode } from "@/components/lead/sections/LeadWorkspaceHeaderAccess";
import { LEAD_CAPTURE_TOUR_ID } from "./tours/leadCapture";
import { OPPORTUNITIES_ENTRY_TOUR_ID } from "./tours/opportunitiesEntry";
import { SALES_CONSOLE_TOUR_ID } from "./tours/salesConsole";
import { ADS_ASSISTANT_TOUR_ID } from "./tours/adsAssistant";

export const FIREFLY_DISCOVERY_DWELL_MS = 45_000;

export type FireflyDiscoveryModeConfig = {
  tourId: string;
  dwellMs: number;
  title: string;
  body: string;
};

export const FIREFLY_DISCOVERY_BY_MODE: Partial<Record<PrimaryMode, FireflyDiscoveryModeConfig>> = {
  leads: {
    tourId: LEAD_CAPTURE_TOUR_ID,
    dwellMs: FIREFLY_DISCOVERY_DWELL_MS,
    title: "Quick look at lead capture?",
    body: "A short guided tour on Leads — dismiss anytime.",
  },
  opportunities: {
    tourId: OPPORTUNITIES_ENTRY_TOUR_ID,
    dwellMs: FIREFLY_DISCOVERY_DWELL_MS,
    title: "New to Opportunities?",
    body: "A short tour on starting a deal and proposal package — dismiss anytime.",
  },
  salesConsole: {
    tourId: SALES_CONSOLE_TOUR_ID,
    dwellMs: FIREFLY_DISCOVERY_DWELL_MS,
    title: "Quick look at Sales Console?",
    body: "RTO calculator, checklist, follow-ups, and notes — a short guided tour.",
  },
  adsAssistant: {
    tourId: ADS_ASSISTANT_TOUR_ID,
    dwellMs: FIREFLY_DISCOVERY_DWELL_MS,
    title: "Quick look at Ads Assistant?",
    body: "Log today's social post and browse coaching — a short guided tour.",
  },
};

export function getFireflyDiscoveryConfigForMode(
  mode: PrimaryMode,
): FireflyDiscoveryModeConfig | null {
  return FIREFLY_DISCOVERY_BY_MODE[mode] ?? null;
}
